'use client';

import dynamic from 'next/dynamic';

import { Badge, BadgeProps } from '@/components/ui/badge';
import { useAuth } from '@/contexts/auth-context';
import { useInfiniteNotifications } from '@/hooks/use-infinite-notifications';

export default dynamic(() => Promise.resolve(NotificationBadge), {
  ssr: false,
});

type NotificationFilter = 'all' | 'messages' | 'general';

type NotificationBadgeProps = {
  className?: string;
  size?: BadgeProps['size'];
  type?: NotificationFilter;
  count?: number;
};

function NotificationBadge({
  className,
  size,
  type = 'all',
  count: externalCount,
}: NotificationBadgeProps) {
  const { user } = useAuth();
  const { getCounts } = useInfiniteNotifications(user?.id);

  const counts = getCounts();
  const count = externalCount !== undefined ? externalCount : counts[type];

  if (count === 0) {
    return null;
  }

  const displayCount = count > 99 ? '99+' : count;

  return (
    <Badge size={size} variant='notification-count' className={className}>
      {displayCount}
    </Badge>
  );
}
